<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kDuGbb/images/cover.jpg?1712288233317" alt="This image is the cover for the book Target Zero"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Target Zero
      </h1>
      <p class="bookDescription body article font2">
        <p>Former Black Panther information minister Eldridge Cleaver was a complex man who inspired profound adulation, love, rage, and, among many, fear. <i>Target Zero </i>brings Cleaver's controversial story into focus through his own words. This books charts Cleaver's life through his writings: his quiet childhood, his youth spent in prison, his startling emergence as a Black Panther leader who became a "fugitive from justice" by the end of 1968, his seven-year exile, and his religious and political conversion following his return to the U.S. <i>Target Zero</i>, which brings together previously unpublished essays, short stories, letters, interviews, and poems, is the most significant collection of Eldridge Cleaver's writing since his bestselling book <i>Soul on Ice (1968).</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eldridge Cleaver, Kathleen Cleaver, Henry Louis Gates, Cecil Brown
      </h2>
      
      <p class="authorDescription body article"><B>Eldridge Cleaver</B> is the celebrated author of <I>Soul on Ice</I> and was the information minister of the Black Panther Party. <B>Kathleen Cleaver</B> is a senior lecturer at Yale University and at Emory Law School. She joined Eldridge Cleaver in the Black Panther Party in 1967, when they married. She is an attorney and author, and is currently at work on her memoir, <I>Memories of Love and War</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b5d1d630